module.exports = __webpack_public_path__ + "media/country_flags/hu-63a4b74b.png";